<template>
    <div class="b-table-sticky-header table-responsive mt-1">
        <b-table-simple
            no-border-collapse
            small
            class="mb-0"
        >
            <b-thead>
                <b-tr>
                    <b-th
                        class="text-center"
                    >
                        {{ $t('v4.Week') }}
                    </b-th>
                    <b-th
                        class="text-center"
                    >
                        {{ $t('v4.Date') }}
                    </b-th>
                    <b-th
                        v-for="(dayStr, index) in daysString" :key="`d-${index}`"
                        class="text-right"
                    >
                        {{ $t(`v4.${dayStr}`) }}
                    </b-th>
                </b-tr>
            </b-thead>
                <b-tbody>
                    <b-tr v-for="(week, weekIdx) in data.yKeys" :key="`week-${weekIdx}`">
                        <b-td class="text-center">
                            {{ __getOrdinal(week) }}
                        </b-td>
                        <b-td class="text-center text-nowrap">
                            {{ findWeekStartDate(week) }} - {{ findWeekEndDate(week) }}
                        </b-td>
                        <b-td
                            class="text-right"
                            v-for="(value) in days"
                            :key="`cost-${value}`"
                        >
                            {{ (weeklyCostMap[week] && weeklyCostMap[week][value] && $_getDollar(weeklyCostMap[week][value].cost).replace(' ','')) || '-' }}
                        </b-td>
                    </b-tr>
                </b-tbody>
        </b-table-simple>
    </div>
</template>
<script>
import useCommonData from '@/composables/useCommonData'
import { toRefs, computed } from '@vue/composition-api'
export default {
    props: ['data'],
    setup (props, context) {
        const { data } = toRefs(props)
        const { __getOrdinal, __getDayString } = useCommonData()
        const days = ['1', '2', '3', '4', '5', '6', '7']
        const daysString = days.map(day => __getDayString(day))
        const findWeekStartDate = (week) => {
            const findItem = data.value.weeks.find(item => item.week === week && item.day === '1')
            if (findItem) {
                return findItem.date.substring(2, 12).replaceAll('-', '.')
            } else {
                return ''
            }
        }
        const findWeekEndDate = (week) => {
            const findItem = data.value.weeks.find(item => item.week === week && item.day === '7')
            if (findItem) {
                return findItem.date.substring(2, 12).replaceAll('-', '.')
            } else {
                return ''
            }
        }
        const weeklyCostMap = computed(() => {
            return data.value.weeks.reduce((accumulator, currentValue) => {
                if (!accumulator[currentValue.week]) {
                    accumulator[currentValue.week] = {}
                }
                accumulator[currentValue.week][currentValue.day] = currentValue
                return accumulator
            }, {})
        })
        return {
            days,
            daysString,
            findWeekStartDate,
            findWeekEndDate,
            __getOrdinal,
            weeklyCostMap
        }
    }
}
</script>
